import { render, staticRenderFns } from "./TransferToMarketplacePopup.vue?vue&type=template&id=9d990c34&scoped=true"
import script from "./TransferToMarketplacePopup.vue?vue&type=script&lang=js"
export * from "./TransferToMarketplacePopup.vue?vue&type=script&lang=js"
import style0 from "./TransferToMarketplacePopup.vue?vue&type=style&index=0&id=9d990c34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d990c34",
  null
  
)

export default component.exports